import * as L from "leaflet";
import { removeAllDrawnLayers } from "src/utils/map.utils";

// TODO: this should be removed with new draw, select, lasso functionality
export function useSegmentDraw(
  map: L.Map,
  callbacks: {
    onDraw: (drawing: string) => void;
  }
) {
  /**
   * Functions
   */

  function startDrawing() {
    // map.pm.setGlobalOptions({ hideMiddleMarkers: true });
    map.on("pm:drawstart", (event) => {
      // @ts-ignore: leaflet-geoman type definition insufficient
      const { workingLayer } = event;

      workingLayer.on("pm:vertexadded", (e: any) => {
        // @ts-ignore
        if (workingLayer.getLatLngs().length >= 2) {
          // @ts-ignore
          map.pm.Draw.Line._finishShape();
          callbacks.onDraw(e.workingLayer.toGeoJSON());
          removeAllDrawnLayers(map);
        }
      });
    });
    map.pm.enableDraw("Line");

    return function cleanup() {
      map.off("pm:drawstart");
    };
  }

  function stopDrawing() {
    map.pm.disableDraw("Line");
  }

  return {
    startDrawing,
    stopDrawing,
  };
}
